function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    let target = event.target;
    if (target.tagName == "path") {
      target = target.parentNode;
    }
    if (target.tagName == "svg" && target.classList.contains("icon-close")) {
      event.preventDefault();
      const summaryElement = this.mainDetailsToggle.querySelector('summary');
      this.closeMenuDrawer(event, summaryElement);
      summaryElement.setAttribute('aria-expanded', false);
      return;
    }

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);

    const headerIcon = document.querySelector('.header__icon--menu');
    if (headerIcon) {
      headerIcon.setAttribute('aria-expanded', 'false');
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('body-no-scroll');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('body-no-scroll');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSticky();
      this.updatePrice();
      updateStockLabel(this.currentVariant.id);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const wishlistButton = document.querySelectorAll(`#MainContent ${selectors.button}`);
    wishlistButton.forEach((button) => {
      button.dataset.sku = this.currentVariant.sku;
      button.dataset.size = this.currentVariant.title;
      button.dataset.variantId = this.currentVariant.id;
    })
  }

  updateSticky() {
    const sticky = document.querySelector(`#addToCartForm .product-attributes>div[data-value='${this.currentVariant.title}']`);
    if (sticky) {
      if (sticky.dataset["wasclicked"] != 'true') {
        sticky.querySelector("input").click();
      }
      sticky.dataset["wasclicked"] = 'false';
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updatePrice() {
    const formatter = new Intl.NumberFormat(Shopify.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const selector = ".product-main-section-wrapper .product-price-wrapper .price, .product-main-section-wrapper .sticky-product-details .price";
    if (this.currentVariant.compare_at_price) {
      const regular = window.shopMoneyFormat.replace(/{{.+}}/, formatter.format(this.currentVariant.compare_at_price / 100));
      const promo = window.shopMoneyFormat.replace(/{{.+}}/, formatter.format(this.currentVariant.price / 100));
      document.querySelectorAll(selector).forEach(price => {
        price.classList.add("price--on-sale");
        price.querySelector(".price__sale .price-item--regular").textContent = regular;
        price.querySelector(".price__sale .price-item--sale").textContent = promo;
      });
    } else {
      const regular = window.shopMoneyFormat.replace(/{{.+}}/, formatter.format(this.currentVariant.price / 100));
      document.querySelectorAll(selector).forEach(price => {
        price.classList.remove("price--on-sale");
        price.querySelector(".price__regular .price-item--regular").textContent = regular;
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    const stickyAddToCart = document.querySelector("#addToCartForm .add-to-cart");

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (stickyAddToCart) {
        stickyAddToCart.setAttribute('disabled', 'disabled');
        if (text) stickyAddToCart.querySelector("span").textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (stickyAddToCart) {
        stickyAddToCart.removeAttribute('disabled');
        stickyAddToCart.querySelector("span").textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset .product-attributes'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* Product preview popup */
async function openProductPreviewPopup(productHandle, customProperty = null) {
  const preview_container = document.getElementById("product-preview-content");
  preview_container.innerHTML = '<div class="popup-loading"></div>';
  const req = fetch(`/products/${productHandle}?view=card&type=preview`).then(res => { return res.text() });
  const preview_root = document.querySelector(".js-menu__context_product-preview");
  preview_root.classList.add("js-menu__expanded_product-preview");
  preview_root.querySelector(".js-menu-preview").classList.add("js-menu__expanded_product-preview");
  document.querySelector("body").classList.add("popup");

  const content = await req;
  if (content.startsWith("<div")) {
    preview_container.innerHTML = content;
    // hide the color swatch title if there is no swatches
    const empty_color_swatches = document.querySelectorAll(".product-preview-swatches .selected").length == 0;
    const colors_title = document.querySelector(".select-title.colors-title");
    if (colors_title && empty_color_swatches) {
      colors_title.classList.add("hidden");
    }

    // select first available variant
    const first_variant = document.querySelector(".product-preview-sizes label:not(.unavailable)");
    if (first_variant) {
      first_variant.click();
    } else {
      previewPopupOptionChange(true);
    }

    if (!customProperty) {
      customProperty = { name: "quick_view", value: "true" };
    }

    if (customProperty.name && customProperty.value) {
      const submit = preview_container.querySelector(".product-preview-submit");
      submit.dataset.customPropName = customProperty.name;
      submit.dataset.customPropValue = customProperty.value;
    }

    // setup wishlist button
    setupButtons([document.querySelector("#product-preview-form .product-preview-wishlist")]);
  } else {
    preview_container.innerHTML = `<span>Error: this product does not exist in this store
    (<a href="/products/${productHandle}" target="_blank">${productHandle}<a/>).</span>`;
  }
}

function getProductPreviewOptionsData(elem) {
	const variants = {};
	elem.dataset.variants.split(",").forEach(variant => {
		const data = variant.split(":");
		if (data.length != 4) { return }
		variants[data[0]] = {
			id: parseInt(data[1]),
      sku: data[2],
			available: data[3] == "true"
		};
	});
	return variants;
}

function getProductPreviewSelectedOptions(options) {
  const selected = [];
  options.querySelectorAll(".product-preview-option-values").forEach(values => {
    const checked = values.querySelector("input:checked");
    if (checked) {
      selected.push(checked.value);
    }
  });
  return selected;
}

function setProductPreviewOptionsAvailability(options, variants, current) {
  const selected = current.split(" / ");
  for (let i = 0; i < selected.length; i++) {
    let start = "";
    for (let j = (i - 1); j > -1; j--) {
      if (start == "") {
        start = selected[j];
      } else {
        start = `${selected[j]} / ${start}`;
      }
    }
    const toCheck = Object.keys(variants).filter(name => name.startsWith(start));
    options.querySelectorAll(`.product-preview-option:nth-child(${i + 1}) input`).forEach(input => {
      const start2 = (start == "") ? input.value : `${start} / ${input.value}`;
      const toCheck2 = toCheck.filter(name => name.startsWith(start2));
      available = false;
      for (let j = 0; j < toCheck2.length; j++) {
        if (variants[toCheck2[j]].available) {
          available = true;
          break;
        }
      }
      if (available) {
        input.removeAttribute("disabled");
        input.nextElementSibling.classList.remove("unavailable");
      } else {
        input.setAttribute("disabled", "");
        input.nextElementSibling.classList.add("unavailable");
      }
    });
  }
}

function previewPopupOptionChange(fromInit = false) {
  const form = document.getElementById("product-preview-form");
  if (!form) {
    return;
  }

  const options = form.querySelector(".product-preview-options");
  if (options) {
    const variants = getProductPreviewOptionsData(options);
    let firstAvailable = null;
    if (fromInit) {
      const names = Object.keys(variants);
      for (let i = 0; i < names.length; i++) {
        if (variants[names[i]].available) {
          firstAvailable = names[i];
          break;
        }
      }
    }
    if (firstAvailable) {
      const selected = firstAvailable.split(" / ");
      for (let i = 0; i < selected.length; i++) {
        options.querySelector(`.product-preview-option:nth-child(${i + 1}) input[value="${selected[i]}"]`).checked = true;
      }
    } else {
      options.querySelectorAll(".product-preview-option-values").forEach(values => {
        const checked = values.querySelector("input:checked");
        if (!checked) {
          values.querySelector("input").checked = true;
        }
      });
    }

    const name = getProductPreviewSelectedOptions(options).join(" / ");
    const variant = variants[name];
    const addButton = form.querySelector("button.product-preview-submit");
    if (variant) {
      previewSizeChangeWishlist(variant.id, variant.sku, variant.size);
      if (variant.available) {
        addButton.removeAttribute("disabled");
      } else {
        addButton.setAttribute("disabled", "");
      }
      setProductPreviewOptionsAvailability(options, variants, name);
    } else {
      addButton.setAttribute("disabled", "");
    }
  }
}

async function submitProductPreviewPopup() {
  const form = document.getElementById("product-preview-form");
  if (!form) {
    return;
  }
  const submit = form.querySelector(".product-preview-submit");
  if (submit.dataset["clicked"] == "true") {
    return;
  }
  submit.dataset["clicked"] = "true";

  let id = form.dataset["productid"];
  const sizes = form.querySelectorAll(".product-preview-sizes input");
  if (sizes.length > 0) {
    const size = form.querySelector(".product-preview-sizes input:checked");
    if (size) {
      id = size.value;
    } else {
      submit.dataset["clicked"] = '';
      return;
    }
  } else {
    const options = form.querySelector(".product-preview-options");
    if (options) {
      let found = false;
      try {
        const variants = getProductPreviewOptionsData(options);
        const name = getProductPreviewSelectedOptions(options).join(" / ");
        const variant = variants[name];
        if (variant) {
          id = variants[name].id;
          found = variants[name].available;
        }
      } catch (err) {
        console.error(err.message);
      }
      if (!found) {
        submit.dataset["clicked"] = '';
        return;
      }
    }
  }

  const addData = new FormData();
  addData.append('id', id);
  addData.append('quantity', 1);
  const replacement_image = form.querySelector("img.was-video");
  if (replacement_image) {
    addData.append('properties[product_media]', replacement_image.src.replace(/^https?:/, ""));
  }
  const customPropertyName = submit.dataset.customPropName;
  const customPropertyValue = submit.dataset.customPropValue;
  if (customPropertyName && customPropertyValue) {
    addData.append(`properties[${customPropertyName}]`, customPropertyValue);
  }

  fetch("/cart/add", {
    method: "POST",
    body: addData
  }).then(res => {
    closeProductPreviewPopup();
    refreshCart();
  }).finally(() => { submit.dataset["clicked"] = '' })
}

function closeProductPreviewPopup() {
  const preview_root = document.querySelector(".js-menu__context_product-preview");
  preview_root.classList.remove("js-menu__expanded_product-preview");
  preview_root.querySelector(".js-menu-preview").classList.remove("js-menu__expanded_product-preview");
  const otherPopups = document.querySelectorAll(".js-menu__expanded_wish, .js-menu__expanded");
  if (otherPopups.length == 0) {
    document.querySelector("body").classList.remove("popup");
  }
}

document.querySelector(".js-menu-preview-close").addEventListener("click", closeProductPreviewPopup);

document.querySelector(".js-menu__context_product-preview").addEventListener("click", (event) => {
  if (event.target === event.currentTarget) {
    closeProductPreviewPopup();
  }
});

window.previewSizeScroll = {
  target: null,
  origin: 0
};

function previewPopupSizeScrollStart(event) {
  if (event.target.classList.contains("product-preview-sizes") || event.target.classList.contains("product-preview-option-values")) {
    window.previewSizeScroll.target = event.target;
  } else {
    window.previewSizeScroll.target = event.target.closest(".product-preview-sizes");
    if (!window.previewSizeScroll.target) {
      window.previewSizeScroll.target = event.target.closest(".product-preview-option-values");
    }
  }
  window.previewSizeScroll.origin = event.clientX;
}

function previewPopupSizeScrollStop(event) {
  window.previewSizeScroll.target = false;
}

function previewPopupSizeScroll(event) {
  if (window.previewSizeScroll.target) {
    const distance = window.previewSizeScroll.origin - event.clientX;
    window.previewSizeScroll.target.scrollBy(distance, 0);
    window.previewSizeScroll.origin = event.clientX;
  }
}

function previewSizeChangeWishlist(variantId, sku, size) {
  const wishlistButton = document.getElementById("product-preview-form").querySelector(selectors.button);
  wishlistButton.dataset.sku = sku;
  wishlistButton.dataset.size = size;
  wishlistButton.dataset.variantId = variantId;
}

function swatchesChangeVariantWithSelected(elem) {
  let parent = elem.closest("#product-preview-content");
  if (parent) {
    openProductPreviewPopup(elem.dataset.handle);
    return;
  }

  let imgSelector, titleSelector, priceSelector, promoSelector;
  const badgeSelector = ".badge_sale";
  const collectionSelector = ".collection-title";
  const replacementUrl = `/products/${elem.dataset.handle}`;
  parent = elem.closest(".fs-recommendation-product-container");
  if (parent) {
    imgSelector = ".fs-recommendation-product-image";
    titleSelector = ".fs-recommendation-product-name-wrapper";
    priceSelector = ".fs-recommendation-product-price";
    promoSelector = "";
    parent.href = replacementUrl;
  } else {
    parent = elem.closest(".fs-product-card");
    if (parent) {
      imgSelector = ".image-container img";
      titleSelector = ".fs-product-title";
      priceSelector = ".price";
      promoSelector = ".fs-compare";
      const imgLink = parent.querySelector(".fs-product-main-image-wrapper");
      imgLink.href = replacementUrl;
      imgLink.replaceWith(imgLink.cloneNode(true));
      const titleLink = parent.querySelector(".fs-serp-product-title");
      titleLink.href = replacementUrl;
      titleLink.replaceWith(titleLink.cloneNode(true));
    } else {
      return;
    }
  }

  parent.dataset.id = elem.dataset.id;
  elem.parentNode.querySelectorAll(".selected").forEach(node => {
    node.classList.remove("selected");
  })
  elem.querySelectorAll("*").forEach(node => {
    node.classList.add("selected");
  });
  elem.classList.add("selected");
  parent.querySelector(imgSelector).src = elem.querySelector("img").dataset.highres;
  parent.querySelector(".product-preview-swatches").dataset.original = elem.querySelector("img").dataset.highres;

  let title = elem.dataset.name;
  let collection = parent.querySelector(collectionSelector).textContent;
  if (title.includes("’")) {
    collection = collection.replaceAll("'", "’");
  }
  if (title.includes(collection)) {
    title = title.replaceAll(collection, "");
  } else {
    collection.split(" ").forEach(word => {
      if (word.length == 1) {
        word = ` ${word} `;
      } 
      title = title.replaceAll(word, "");
    });
  }
  title = title.replace(/^[\s\-\/]+/, "");

  parent.querySelector(titleSelector).textContent = title;
  const priceElem = parent.querySelector(priceSelector);
  if (promoSelector == "") {
    if (elem.dataset.compare == "") {
      priceElem.innerHTML = elem.dataset.priceFormatted;
      priceElem.style.color = "#070707";
    } else {
      priceElem.innerHTML = `${elem.dataset.priceFormatted}
      <span class="previous-price fs-recommendation-product-previous-price" style="text-decoration: line-through;">${elem.dataset.compareFormatted}</span>`;
      priceElem.style.color = "";
    }
  } else {
    const promoElem = parent.querySelector(promoSelector);
    priceElem.innerHTML = elem.dataset.priceFormatted;
    if (promoElem) {
      if (elem.dataset.compare == "") {
        priceElem.style.color = "#070707";
        promoElem.innerHTML = "";
      } else {
        priceElem.style.color = "";
        promoElem.innerHTML = elem.dataset.compareFormatted;
      }
    } else {
      priceElem.style.color = "";
      if (elem.dataset.compare != "") {
        priceElem.innerHTML = `<span style="text-decoration: line-through;">${elem.dataset.compareFormatted}</span>
        <span style="color:#db5957;">${elem.dataset.priceFormatted}</span>`;
      }
    }
  }

  const badge = parent.querySelector(badgeSelector);
  if (badge) {
    if (elem.dataset.compare == "") {
      badge.style.opacity = "0";
    } else {
      badge.style.opacity = "";
      const text = badge.textContent.split(" ");
      const price = (1 - parseInt(elem.dataset.price) / parseInt(elem.dataset.compare)) * 100;
      for (let i = 0; i < text.length; i++) {
        if (text[i].match(/[0-9]/)) {
          text[i] = `${price.toFixed(0)}%`;
          break;
        }
      }
      badge.textContent = text.join(" ");
    }
  }
}

function removeFromCartById(id) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: id,
      quantity: 0
    })
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector("#menu-drawer .menu-drawer__navigation-container");
  const menu = container.querySelector(".menu-drawer__navigation");
  const frameTime = 1000 / 60;

  const thumb = document.createElement("div");
  thumb.classList.add("menu-drawer-custom-scrollbar-thumb");
  const scrollbar = document.createElement("div");
  scrollbar.classList.add("menu-drawer-custom-scrollbar");
  scrollbar.appendChild(thumb);
  container.appendChild(scrollbar);

  function isSubmenuOpen() {
    return container.querySelector("details[open]") !== null;
  }


  setInterval(() => {
    const scrollbar = container.querySelector(".menu-drawer-custom-scrollbar");
    
    if (isSubmenuOpen()) {
      scrollbar.style.display = "none";
      menu.style.overflow = "hidden";
      return;
    }

    const maxScroll = menu.scrollHeight - menu.clientHeight;
    if (maxScroll <= 0) {
      scrollbar.style.display = "none";
    } else {
      scrollbar.style.display = "";
      menu.style.overflow = "auto";
      scrollbar.style.top = `${menu.getBoundingClientRect().top}px`;
      scrollbar.style.height = `${menu.clientHeight}px`;

      const position = ((menu.scrollTop / maxScroll) * 100) * 0.9;
      scrollbar.querySelector(".menu-drawer-custom-scrollbar-thumb").style.top = `${position}%`;
    }
  }, frameTime);
});

document.addEventListener('DOMContentLoaded', function () {
  const submenus = document.querySelectorAll('.menu-drawer__inner-submenu');

  submenus.forEach(submenu => {
    const scrollbar = submenu.querySelector('.inner-submenu-custom-scrollbar');
    const thumb = submenu.querySelector('.inner-submenu-custom-scrollbar-thumb');

    if (!scrollbar || !thumb) return;

    function updateThumb() {
      const contentHeight = submenu.scrollHeight;
      const visibleHeight = submenu.clientHeight;

       scrollbar.style.height = visibleHeight + 'px';

      // cacher la scrollbar si pas besoin
      if (contentHeight <= visibleHeight || visibleHeight === 0) {
        scrollbar.style.display = 'none';
        return;
      } else {
        scrollbar.style.display = 'block';
      }

      // utilise visibleHeight comme trackHeight
      const trackHeight = visibleHeight;

      const thumbHeight = Math.min(
        Math.max(Math.round((visibleHeight / contentHeight) * trackHeight), 24),
        120
      );
      thumb.style.height = thumbHeight + 'px';

      const maxThumbTop = trackHeight - thumbHeight;
      const scrollRatio = submenu.scrollTop / (contentHeight - visibleHeight);
      const thumbTop = scrollRatio * maxThumbTop;

      thumb.style.transform = `translateY(${thumbTop}px)`;
    }

    submenu.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);

    // Drag support (pointer events pour desktop + mobile)
    let dragging = false;
    let startY = 0;
    let startScrollTop = 0;

    thumb.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      dragging = true;
      startY = e.clientY;
      startScrollTop = submenu.scrollTop;
      document.body.classList.add('no-select');
      try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
    });

    document.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const deltaY = e.clientY - startY;
      const contentHeight = submenu.scrollHeight;
      const visibleHeight = submenu.clientHeight;
      const trackHeight = scrollbar.clientHeight;
      const thumbH = thumb.offsetHeight;
      const scrollRatio = (contentHeight - visibleHeight) / Math.max(trackHeight - thumbH, 1);
      submenu.scrollTop = startScrollTop + deltaY * scrollRatio;
    });

    document.addEventListener('pointerup', (e) => {
      if (!dragging) return;
      dragging = false;
      document.body.classList.remove('no-select');
      try { thumb.releasePointerCapture(e.pointerId); } catch (err) {}
    });

    // clic sur la track -> sauter à l'endroit cliqué
    scrollbar.addEventListener('click', (e) => {
      if (e.target !== scrollbar) return;
      const rect = scrollbar.getBoundingClientRect();
      const clickY = e.clientY - rect.top;
      const targetTop = clickY - (thumb.offsetHeight / 2);
      const maxTop = scrollbar.clientHeight - thumb.offsetHeight;
      const clamped = Math.max(0, Math.min(targetTop, maxTop));
      const ratio = clamped / Math.max(maxTop, 1);
      submenu.scrollTop = ratio * (submenu.scrollHeight - submenu.clientHeight);
    });

    const mo = new MutationObserver(() => {
      requestAnimationFrame(updateThumb);
    });
    mo.observe(submenu, { childList: true, subtree: true, characterData: true });

    const parentDetails = submenu.closest('details');
    if (parentDetails) {
      parentDetails.addEventListener('toggle', () => {
        setTimeout(updateThumb, 50);
      });
    }

    setTimeout(updateThumb, 50);
  });
});